<template>
  <section class="product-catalog">
    <div class="container">
      <h2 class="product-catalog__title title center">{{ title }}</h2>
      <p
        style="text-align: center"
        class="product-catalog__description description center"
      >
        {{ description }}
      </p>

      <ul
        class="product-catalog__categories mt mb"
        v-if="subcategories.length > 0"
      >
        <li v-for="cat in subcategories" :key="cat.id">
          <NuxtLink :to="`/catalog/${cat.id}`">{{ cat.name }}</NuxtLink>
        </li>
      </ul>

      <!-- FilterProducts temporarily hidden — TODO: redesign filters -->
      <!-- <FilterProducts
        v-if="filters.length > 0"
        :filterProducts="filters"
        @filters="emits('filter', $event)"
      /> -->
      <Pagination :page="page" :count="count" @page="emits('page', $event)" />
      <div class="product-catalog__wrapper" style="margin-top: 6rem">
        <div class="product-catalog__card" v-for="item in items" :key="item.id">
          <NuxtLink :to="`/product/${item.id}`">
            <Card :imgUrl="item.imgPath" :title="item.name" type="info" />
          </NuxtLink>
        </div>
      </div>
      <Pagination :page="page" :count="count" @page="emits('page', $event)" />
      <!--            <div v-if="props.items.length > maxLength" class="product-catalog__btns">-->
      <!--                <Button-->
      <!--                        title="Показать еще"-->
      <!--                        @click="showMore"-->
      <!--                />-->
      <!--            </div>-->
    </div>
  </section>
</template>

<script setup lang="ts">
import Card from "~/components/UI/Card/Card.vue";
import type { PropType } from "vue";
import { Product } from "~/dto/Product";
import { Product as ProductApi } from "~/api/Product";
import Pagination from "~/components/UI/Pagination.vue";
import FilterProducts from "~/components/UI/FilterProducts.vue";
import { Filter } from "~/dto/Filter";
import type { Taxonomy } from "~/dto/Taxonomy";

const emits = defineEmits(["page", "filter"]);
const props = defineProps({
  title: {
    type: String,
    default: "Как создать этот вайб?",
  },
  description: {
    type: String,
    default:
      "Познакомьтесь с услугами, продуктами и концептами наших партнеров, которые вы можете получить через наш сайт",
  },
  items: {
    type: Array as PropType<Product[]>,
    required: true,
  },
  count: {
    type: Number,
    required: true,
  },
  page: {
    type: Number,
    default: 1,
  },
  showFilters: {
    type: Boolean,
    default: true,
  },
  subcategories: {
    type: Array as PropType<Array<Taxonomy>>,
    default: [],
  },
});

const filters = ref<Array<Filter>>([]);
// filters fetch disabled — TODO: redesign filters
// if (props.showFilters) {
//   ProductApi.getFilters().then((data) => (filters.value = data));
// }
</script>
